module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/085-solomon-islands-6ba62eb8fc03e71c52b8c4de99e32831.svg";